import React from 'react';
import { Button, Tooltip, Space, message, Spin, Table, Alert, Card, Modal, Tag, Input, Form, Row, Col, Select } from 'antd';
import { CodeOutlined, PlusOutlined, EditOutlined, DeleteOutlined, ReloadOutlined, CloudDownloadOutlined } from '@ant-design/icons';
import 'antd/dist/antd.css';
import './Headline.scss'

class Headline extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			loading: this.props.status ? this.props.status : false
		}
	};


	render() {
		let { title, Keypad } = this.props
		let { loading } = this.state

		return (
			<div className='Headline'>
				<p className="triangle"></p>
				<p className="title_of">{title}</p>
				{ Keypad ? <Button loading={loading} type="primary" onClick={this.props.derive ? this.props.derive : ""}>{Keypad}</Button> : ""}
			</div>
		)
	}
}
export default Headline;


// WEBPACK FOOTER //
// app/components/customPage/Headline/Headline.jsx